var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_Section_PageHeader',[_c('Help_Section',{attrs:{"info-text":_vm.$t('badges.help-section')}}),_c('Header_Large',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t("badges.title")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }